export interface PreauthSettings {
  showSidebar: boolean; // chat-list sidebar container
  showHome: boolean;  // Home landing + Home nav link + New Chat button
  showDashboard: boolean; // Dashboard nav link + page
  canAskReve: boolean; // Ask Reve button
  canCloneChat: boolean;  // Clone action in the chat menu (ChatThumbnailMenu) + the "Clone to continue" control on closed/read-only chats (ChatInput)
  showSharedChats: boolean;  // related/shared chat tabs & lists
  showClaims: boolean; // claims-table nav entry
  canUploadAttachments: boolean;  // upload / drag-drop control
  canDownloadAttachments: boolean;  // file download control
}

export interface BackendSession {
  authenticated: boolean;
  username?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  // Cognito claims (subset)
  name?: string;
  given_name?: string;
  family_name?: string;
  phone_number?: string;
  picture?: string;
  email_verified?: boolean;
  phone_number_verified?: boolean;
  sub?: string;
  is_admin?: boolean; // User is in admin Cognito group
  signature?: string; // User's signature for PDFs and documents
  is_external?: boolean; // User is in the preauth vertical
  current_tenant?: Tenant;
  available_tenants?: Tenant[];
  groups?: PERMISSIONS[];
  preauth_settings: PreauthSettings;
  // Base64 key (>= 32 random bytes) per user and browser, encrypting the saved filters in
  // localStorage (see filtersTenantStorage). Without it filters are not saved. AuthContext
  // strips it before exposing the user, so only the session payload ever carries it.
  filters_encryption_key?: string | null;
  // Non-secret id of filters_encryption_key; changes only when the key is rotated.
  filters_key_id?: string | null;
}

export interface Tenant {
  id: string;
  is_default: boolean;
  name: string;
  organization: {
    id: string;
    name: string;
    slug: string;
    page_title?: string;
    ask_reve_button_text?: string;
    whitelabel?: boolean;
    logo_url?: string | null;
  };
  role: string;
  slug: string;
  letter_format: {
    header: string;
    footer: string;
  };
}

export interface AppUser {
  username?: string;
  email?: string;
  backend?: BackendSession;
}

export enum PERMISSIONS {
  billing = "billing",
}

export interface IFCHeaderCapabilities {
  home: boolean;
  claims: boolean;
  dashboard: boolean;
  policies: boolean;
  contracts: boolean;
}

export interface IFCCapabilities {
  header: IFCHeaderCapabilities | null;
}